import { render, staticRenderFns } from "./cDatatableAssigPermission.vue?vue&type=template&id=b3a4d614&scoped=true"
import script from "./cDatatableAssigPermission.vue?vue&type=script&lang=js"
export * from "./cDatatableAssigPermission.vue?vue&type=script&lang=js"
import style0 from "./cDatatableAssigPermission.vue?vue&type=style&index=0&id=b3a4d614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a4d614",
  null
  
)

export default component.exports